import { Component, OnInit, Renderer2, AfterViewInit } from "@angular/core";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { FormService } from "../../services/form/form.service";
import { InquiryService } from "../../services/inquiry/inquiry.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../services/language/language.service";
import Instafeed from 'instafeed.js';

declare var jQuery: any;
declare var $: any;

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit, AfterViewInit {


  // Define prevSlide and nextSlide properties
  prevSlide: any;
  nextSlide: any;

  // hideOverlay: boolean = false;
  showPopup: boolean = true;

  closePopup(): void {
    this.showPopup = false;
  }

  public coursesForm: FormGroup;
  public contactForm: FormGroup;
  public contactEventForm: FormGroup;

  // public countries: any[] = [];
  public genders: any[] = [];
  public zones: any[] = [];

  public courses: any[] = [];
  public subcoursesofcourse: any[] = [];
  public subcourseslist: any[] = [];
  public subcoursedetail: any[] = [];

  public responseData;

  public status;
  public msgSuccess;
  public msgSuccessEvent;
  public msgWarning;
  public msgWarningEvent;
  public msgInfo;
  public message;
  public cDescription: any = [];

  public contact_us_header;
  public inquery_txt_caps;
  public submit_btn_txt_caps;
  public something_wrong_txt;
  public message_sent_txt;
  public result;
  public draw;
  public totalRecords;
  public filterdRecords;

  public name: string;
  public contact: string;
  public course: string;
  public zone: string;
  public city: string;
  public subcourse: string;
  public referred: string;
  public others: string;
  public email: string;
  public agree: string;
  public number: number;
  public percentage: number;

  public dreamCourses: string;

  errors: any;

  checkModel = false;

  public formErrors = {
    name: "",
    contact: "",
    zone: "",
    city: "",
    course: "",
    subcourse: "",
    referred: "",
    others: "",
    email: "",
    agree: "",
    message: "",
    number: "",
    percentage: "",

    dreamCourses: "",
  };

  public formEventErrors = {
    name: "",
    // email: "",
    message: "",
    number: "",
  };

  subcoursedetails: any = "about";
  verifyMobileNumber: any = false;
  verifyOTP: any = false;
  verifiedContactNumber: any = false;
  resData: any;
  usrOTP: number;
  wrongOTP: any = false;
  contactNumber: any;
  referalName: any;
  constructor(
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private formService: FormService,
    private inquiryService: InquiryService,
    //private router: Router,
    private router: Router, private route: ActivatedRoute,
    private translate: TranslateService,
    public languageService: LanguageService
  ) {
    this.name = "";
    this.email = "";

    this.contact = "";
    (this.zone = null), (this.city = "");
    this.course = null;
    this.subcourse = null;
    this.referred = "";
    this.others = "";

    this.agree = "";

    this.message = "";

    this.dreamCourses;
    this.createForm();
    this.createEventForm();
    this.getZones();
    this.getCourses();
  }

  ngOnInit() {

    const feed = new Instafeed({

      accessToken:
        'YOUR_INSTAGRAM_ACCESS_TOKEN',

      target: 'instafeed',

      limit: 9,

      template: `
            <a href="{{link}}" target="_blank">
              <img title="{{caption}}" src="{{image}}" />
            </a>
          `
    });

    feed.run();

    // this.router.navigate(['thankyou']);
    this.route.params.subscribe((params: Params) => console.log(params['refer']))
    console.log(this.router.url);
    let checkThirdParty = this.router.url.split('=');
    console.log(checkThirdParty);
    if (checkThirdParty.length > 1) {
      this.referalName = checkThirdParty[1];
    } else {
      this.referalName = "Pacific";
    }

  }

  public createForm() {
    this.contactForm = this.formBuilder.group({
      name: [this.name, Validators.compose([Validators.required])],
      email: [this.email, Validators.compose([Validators.required])],
      // percentage: [this.percentage, Validators.compose([Validators.required])],
      contact: [this.contact, Validators.compose([Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)])],
      zone: [this.zone, Validators.compose([Validators.required])],
      city: [this.city, Validators.compose([Validators.required])],
      course: [this.course, Validators.compose([Validators.required])],
      subcourse: [this.subcourse, Validators.compose([Validators.required])],
      referred: [this.referred],
      // others: [this.others],
      agree: [this.agree, Validators.compose([Validators.required])],
    });

    this.contactForm.valueChanges.subscribe((data) => {
      this.formErrors = this.formService.validateForm(
        this.contactForm,
        this.formErrors,
        true
      );
    });
  }

  public createEventForm() {
    this.contactEventForm = this.formBuilder.group({
      name: [this.name, Validators.compose([Validators.required])],
      // email: [this.email, Validators.compose([Validators.required])],
      number: [this.number, Validators.compose([Validators.required])],
      message: [this.message, Validators.compose([Validators.required])],
    });

    this.contactEventForm.valueChanges.subscribe((data) => {
      this.formEventErrors = this.formService.validateForm(
        this.contactEventForm,
        this.formEventErrors,
        true
      );
    });
  }

  submitForm() {

    this.formService.markFormGroupTouched(this.contactForm);
    this.contactForm.value.referred = this.referalName;

    console.log(this.contactForm);

    // this.contactForm.controls['refered'].setValue(this.referalName);
    // if (this.contactForm.valid && this.verifiedContactNumber == true) {

    console.log(this.contactForm.valid);
    if (this.contactForm.valid) {
      // alert('if');
      // this.inquiryService.sendDetails(this.contactForm.value , this.contactNumber).subscribe(
      this.inquiryService.sendDetails(this.contactForm.value).subscribe(
        (response) => {
          this.responseData = response;
          this.status = this.responseData.status;
          this.message = this.responseData.message;
          console.log(this.responseData);

          if (!this.status) {
            this.msgSuccess = "";
            this.msgWarning = "Something went wrong please try again later.";
            if (this.responseData.result) {
              this.responseData.result.forEach((element) => {
                if (element.id == "name") {
                  this.formErrors.name = element.text;
                }
                if (element.id == "email") {
                  this.formErrors.email = element.text;
                }
                if (element.id == "percentage") {

                  this.formErrors.percentage = element.text;

                }
                if (element.id == "contact") {
                  this.formErrors.contact = element.text;
                }
                if (element.id == "zone") {
                  this.formErrors.zone = element.text;
                }
                if (element.id == "city") {
                  this.formErrors.city = element.text;
                }
                if (element.id == "course") {
                  this.formErrors.course = element.text;
                }
              });
            }
          } else {
            this.msgWarning = "";
            this.msgSuccess = "Thank you for registering for the Pacific University Scholarship. We appreciate your interest and will be contacting you shortly.";
            // this.router.navigate(['thankyou']);
            setTimeout(() => {
              this.router.navigate(['thankyou']);
            }, 3000);
            //  this.router.navigate(['home']);
            this.contactForm.reset();
            this.verifiedContactNumber = false;
            this.contactForm.controls["contact"].enable();
          }
        },
        (err) => {
          console.error(err);
        }
      );
    } else {
      alert('else');
      this.formErrors = this.formService.validateForm(
        this.contactForm,
        this.formErrors,
        false
      );
      this.formErrors.agree =
        "You must agree to the terms and conditions before apply.";
    }
  }

  submitEventForm() {
    alert("Event Form");
    this.formService.markFormGroupTouched(this.contactEventForm);

    console.log(this.contactEventForm);

    this.contactEventForm.value.referred = this.referalName;

    if (this.contactEventForm.valid) {
      this.inquiryService.sendEventDetails(this.contactEventForm.value).subscribe(
        (response) => {
          this.responseData = response;
          this.status = this.responseData.status;
          this.message = this.responseData.message;

          console.log(this.responseData);

          if (!this.status) {
            this.msgSuccessEvent = "";
            this.msgWarningEvent = "Something went wrong please try again later.";
            if (this.responseData.result) {
              this.responseData.result.forEach((element) => {
                if (element.id == "name") {
                  this.formEventErrors.name = element.text;
                }
                if (element.id == "number") {
                  this.formEventErrors.number = element.number;
                }
                if (element.id == "message") {
                  this.formEventErrors.message = element.text;
                }
              });
            }
          } else {
            this.msgWarningEvent = "";
            this.msgSuccessEvent = "Thank you for registering for the Pacific University Scholarship. We appreciate your interest and will be contacting you shortly.";
            setTimeout(() => {
              this.router.navigate(['thankyou']);
            }, 3000);

            this.contactEventForm.reset();
            this.verifiedContactNumber = false;
          }
        },
        (err) => {
          console.error(err);
        }
      );

    } else {
      this.formEventErrors = this.formService.validateForm(
        this.contactEventForm,
        this.formEventErrors,
        false
      );
    }
  }

  getZones() {
    this.zones = [];
    this.inquiryService.getZoneslist().subscribe(
      (response) => {
        this.result = response;
        this.totalRecords = this.result.recordsTotal;
        this.filterdRecords = this.result.recordsFiltered;
        for (let index = 0; index < this.result.data.length; index++) {
          this.zones.push({
            id: this.result.data[index].id,
            country: this.result.data[index].country,
            name: this.result.data[index].name,
            code: this.result.data[index].code,
            status: this.result.data[index].status,
            created_date: this.result.data[index].created_date,
            modified_date: this.result.data[index].modified_date,
          });
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getCourses() {
    this.courses = [];

    this.inquiryService.getCourseslist().subscribe(
      (response) => {
        this.result = response;
        this.draw = response.draw;
        this.totalRecords = response.recordsTotal;
        this.filterdRecords = response.recordsFiltered;
        for (let index = 0; index < this.result.data.length; index++) {
          this.courses.push({
            id: this.result.data[index].id,
            name: this.result.data[index].name,
            description: this.result.data[index].description,
            status: this.result.data[index].status,
            created_date: this.result.data[index].created_date,
            modified_date: this.result.data[index].modified_date,
          });
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getSubcourses(category_id) {
    this.subcoursesofcourse = [];

    this.inquiryService.getSubcourseslist(category_id).subscribe(
      (response) => {
        this.result = response;
        this.totalRecords = response.recordsTotal;
        this.filterdRecords = response.recordsFiltered;
        for (let index = 0; index < this.result.data.length; index++) {
          this.subcoursesofcourse.push({
            id: this.result.data[index].id,
            course_id: this.result.data[index].course_id,
            name: this.result.data[index].name,
            about: this.result.data[index].about,
            contact: this.result.data[index].contact,
            duration: this.result.data[index].duration,
            eligibility: this.result.data[index].eligibility,
            scholarship: this.result.data[index].scholarship,
            status: this.result.data[index].status,
            created_date: this.result.data[index].created_date,
            modified_date: this.result.data[index].modified_date,
          });
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getGender() {
    this.genders = [];

    this.inquiryService.getGenderlist().subscribe(
      (response) => {
        this.result = response;
        this.draw = response.draw;
        this.totalRecords = response.recordsTotal;
        this.filterdRecords = response.recordsFiltered;
        for (let index = 0; index < this.result.data.length; index++) {
          this.genders.push({
            id: this.result.data[index].id,
            title: this.result.data[index].title,
            status: this.result.data[index].status,
            created_date: this.result.data[index].created_date,
            modified_date: this.result.data[index].modified_date,
          });
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  isTermProvided(event: any) {
    this.checkModel = event.target.checked;
  }

  getDescriptiopn(sub_course_id) {
    this.inquiryService.getSubcourseDetail(sub_course_id).subscribe(
      (response) => {
        this.result = response;
        this.subcoursedetail = response.result;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  onChange(value) {
    this.subcoursedetails = value;
  }

  youTube(value) {
    window.open(value);
  }

  mobileNoVerify() {
    this.contactNumber = this.contactForm.value.contact;
    if (this.contactForm.value.contact.toString().length >= 10) {
      this.verifyMobileNumber = true;
    }
  }
  sendOTP() {
    this.verifyMobileNumber = false;
    this.usrOTP = Math.floor(100000 + Math.random() * 900000);
    this.verifyOTP = true;
    this.inquiryService
      .sendOTP(this.usrOTP, this.contactForm.value.contact)
      .subscribe((response) => { });
  }
  verified(data) {
    if (data.target.value == this.usrOTP) {
      this.verifiedContactNumber = true;
      this.verifyOTP = false;
      this.contactForm.controls["contact"].disable({ onlySelf: true });
    } else if (data.target.value.length == 6) {
      this.wrongOTP = true;
    }
  }

  public testimonials = [
    {
      profile: 'assets/image/testimonials/img 03.png',
      name: 'Sunil Charan',
      rating: '★★★★★',
      message: 'I chose PAHER University for my B.Tech, and it was the right decision. The learning environment and facilities helped me grow both technically and professionally.'
    },
    {
      name: 'Ankita Jain',
      profile: 'assets/image/testimonials/img 07.png',
      rating: '★★★★★',
      message: 'My experience studying B. Pharma at PAHER University was very positive. The focus on practical knowledge and industry-oriented learning made a big difference.'
    },
    {
      name: 'Aditi Vaishnav',
      profile: 'assets/image/testimonials/img 05.png',
      rating: '★★★★★',
      message: 'The learning environment at PAHER University is very practical and engaging. My MBA journey here helped me develop leadership and decision-making skills.'
    },
    {
      name: 'Rohit Jaroli',
      profile: 'assets/image/testimonials/img 02.png',
      rating: '★★★★★',
      message: 'Law at PAHER University is not just about books—it’s about thinking, questioning, and understanding justice in a practical way.'
    },
    {
      name: 'Prerak Singh',
      profile: 'assets/image/testimonials/img 04.png',
      rating: '★★★★★',
      message: 'If you want to explore media, creativity, and communication together, PAHER University offers a great platform to start your journey.'
    },
    {
      name: 'Sunita Meena',
      profile: 'assets/image/testimonials/img 06.png',
      rating: '★★★★★',
      message: 'I liked how the Physical Education program at PAHER University combines practical training with the right academic knowledge'
    },
    {
      name: 'Priya Joshi',
      profile: 'assets/image/testimonials/img 08.png',
      rating: '★★★★★',
      message: 'The Dentistry course here is very focused on skill-building. You don’t just learn—you actually get better with practice.'
    }
  ];



  public collageAccordian = [
    {
      id: 1,
      faculty: 'Faculty of Science & Technology',
      courses: [
        {
          college: 'Pacific Institute of Technology',
          subCourses: [
            'B.Tech (CSE/Civil/ME/EE/Mining)',
            'B.Tech(Artificial Intelligence & Machine Learning / Artificial Intelligence & Data Science)',
            'B.Tech (Lateral) (CSE / Civil / ME / EE / Mining)',
            'M.Tech'
          ]
        },
        {
          college: 'Pacific Polytechnic College',
          subCourses: [
            'Diploma (Civil / ME / EE / CSE / Mining)',
            'Diploma (Lateral Entry) (Civil / ME / EE / CSE / Mining)',
          ]
        },
        {
          college: 'Pacific Institute of Computer Science',
          subCourses: [
            'BCA / BCA(Hons.)',
            'PGDCA',
            'MCA',
            'M.Sc (IT, CS)'
          ]
        },
        {
          college: 'Department of Dairy & Food Technology',
          subCourses: [
            'B.Tech (Dairy Technology)'
          ]
        },
        {
          college: 'Pacific College of Basic & Applied Science',
          subCourses: [
            'B.Sc / B.Sc (Hons.) (Physics, Chemistry, Mathematics, Botany, Zoology)',
            'M.Sc (Organic Chemistry / Inorganic Chemistry / Industrial Chemistry / Analytical Chemistry)',
            'M.Sc ((Mathematics) / (Physics) / (Botany, Zoology))',
          ]
        },
        {
          college: 'Pacific Institute of Fire and Safety Management',
          subCourses: [
            'PG Diploma (Industrial Safety & Management / Fire & Safety / Health, Safety & Environment)',
            'B.Sc / B.Sc(Hons.) in Fire & Industrial Safety Management',
            'Diploma in Fire & Safety Management',
            'Certificate in (Health, Safety & Environment / Industrial Safety & Disaster Management / Fire & Safety Management)',
          ]
        }
      ]
    },

    {
      id: 2,
      faculty: 'Faculty of Commerce & Management',
      courses: [
        {
          college: 'Pacific Institute of Management',
          subCourses: [
            'MBA (Dual Specialization / Business Analytics / Hospital Administration / Digital Marketing (Minor Event Mgmt) / (Executive))',
          ]
        },
        {
          college: 'Pacific Institute of Business Studies',
          subCourses: [
            'BBA / BBA (Hons.)',
            'BBA (Global Business Management)',
            'B.Com / B.Com (Hons.)',
            'B.Com with ACCA (UK)',
            'BBA Financial Markets',
            'BBA (Digital Marketing / Business Analytics / Entrepreneurship)',
            'M.Com'
          ]
        },
        {
          college: 'Pacific College of Management',
          subCourses: [
            'BBA',
            'B.Com',
            'M.Com'
          ]
        },
        {
          college: 'Pacific Institute of Hotel Management',
          subCourses: [
            'Certificate Course in Hotel Management (CCHM)',
            'Diploma in Hotel Management (DHM)',
            'B.Sc / B.Sc (Hons.) Hotel Management',
            'BHMCT',
            'Master in Tourism & Hotel Management',
            'Diploma in Bakery & Confectionery'
          ]
        }
      ]
    },

    {
      id: 3,
      faculty: 'Faculty of Social Science & Humanities',
      courses: [
        {
          college: 'Pacific College of Social Science & Humanities',
          subCourses: [
            'BA / BA(Hons.)',
            'MA',
            'Master of Social Work (MSW)'
          ]
        },
        {
          college: 'Department of Media & Mass Communication',
          subCourses: [
            'Diploma in Journalism & Mass Communication',
            'BA / BA(Hons.) in Journalism & Mass Communication',
            'MA in Journalism & Mass Communication'
          ]
        },
        {
          college: 'Department of Yogic Science',
          subCourses: [
            'Certificate in Yogic Science',
            'Diploma in Yogic Science',
            'PG Diploma in Yogic Science',
            'BA / BA(Hons.) in Yogic Science',
            'MA in Yogic Science',
            'M.Sc in Yogic Science'
          ]
        },
        {
          college: 'Department of Library Science',
          subCourses: [
            'D.LIB',
            'B.LIB',
            'M.LIB'
          ]
        }
      ]
    },

    {
      id: 4,
      faculty: 'Faculty of Education',
      courses: [
        {
          college: 'Pacific College of Teachers Education',
          subCourses: [
            'ITEP',
            'D.El.Ed',
            'B.Ed.',
            'MA Education'
          ]
        },
        {
          college: 'Pacific College of Physical Education',
          subCourses: [
            'B.PEd',
            'M.P.Ed'
          ]
        }
      ]
    },

    {
      id: 5,
      faculty: 'Faculty of Pharmacy',
      courses: [
        {
          college: 'Pacific College of Pharmacy',
          subCourses: [
            'D.Pharm',
            'B.Pharm',
            'M.Pharm'
          ]
        },
        {
          college: 'Pacific Insitute of Pharmacy',
          subCourses: [
            'Pharm D',
            'Pharm D (PB)'
          ]
        },
        {
          college: 'Vatsalya College of Pharmacy',
          subCourses: [
            'B.Pharm',
            'M.Pharm'
          ]
        }
      ]
    },

    {
      id: 6,
      faculty: 'Faculty of Law',
      courses: [
        {
          college: 'Pacific School of Law',
          subCourses: [
            'BA + LLB',
            'LLB',
            'LLM (One Year / Two Years)',
          ]
        }
      ]
    },


  ];

  public placements = [
    {
      image: 'assets/image/placements/1.jpeg'
    }, {
      image: 'assets/image/placements/2.jpeg'
    }, {
      image: 'assets/image/placements/3.jpeg'
    }, {
      image: 'assets/image/placements/4.jpeg'
    }, {
      image: 'assets/image/placements/5.jpeg'
    }
  ];

  ngAfterViewInit(): void {
    setTimeout(() => {
      $('.testimonial-wrapper').owlCarousel({
        loop: true,
        margin: 20,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        responsive: {
          0: {
            items: 1
          },
          768: {
            items: 3
          }
        }
      });

      $('.carousel-inner-owl').owlCarousel({
        loop: true,
        margin: 20,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        items: 1,
      });

      $('.placements-wrapper').owlCarousel({
        loop: true,
        margin: 20,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        responsive: {
          0: {
            items: 2
          },
          768: {
            items: 3
          }
        }
      });
    }, 1000);



  }
}